import { connect } from 'react-redux'
import fetchDates from '../../sagas/fetchDates'
import requestRemoveCustomDate from '../../sagas/requestRemoveCustomDate'
import requestChangeCustomDate from '../../sagas/requestChangeCustomDate'
import requestRenameCustomDate from '../../sagas/requestRenameCustomDate'
import { sagaActions as rootSagaActions } from 'store/sagas'
import datesSelector from './datesSelector'
import Dates from './Dates'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  datesSelector,
  {
    fetchDates,
    requestRemoveCustomDate,
    requestRenameCustomDate,
    requestChangeCustomDate,
    requestRemovePersonalDate: rootSagaActions.requestRemovePersonalDate,
    requestRenamePersonalDate: rootSagaActions.requestRenamePersonalDate,
    requestChangePersonalDate: rootSagaActions.requestChangePersonalDate
  }
)(Dates))
